module.exports = __webpack_public_path__ + "static/img/user_avatar05.00fa12c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user_avatar05.png
// module id = J6j8
// module chunks = 1